import { Container, IDestroyOptions } from "pixi.js";
import { Scales } from "../../../../canvas/CanvasScaler";
import { ICanvasScaler } from "../../../../canvas/ICanvasScaler";

export class BasePageView extends Container {
    protected readonly canvasScaler: ICanvasScaler;

    public constructor(canvasScaler: ICanvasScaler) {
        super();
        this.canvasScaler = canvasScaler;
        this.once("removed", this.destroy.bind(this, { children: true, texture: false, baseTexture: false }));
    }

    protected build(): void {
        this.layout(this.canvasScaler.referenceWidth, this.canvasScaler.referenceHeight);
    }

    protected layout(width: number, height: number): void { }

    public override destroy(options?: boolean | IDestroyOptions): void {
        super.destroy(options);
    }
}
